<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>超3天欠货货期</div>
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
            >{{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form
                v-if="resData"
                :inline="true"
                :model="form"
                class="demo-form-inline"
              >
                <el-form-item>
                  <el-select
                    v-model="form.supply_id"
                    :remote-method="remoteSupply"
                    remote
                    filterable
                    placeholder="商家"
                  >
                    <el-option label="全部" value="0"></el-option>
                    <el-option
                      v-for="(item, index) in selections.supply"
                      :key="index"
                      :value="item.supply_id"
                      :label="item.supply_name"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_no"
                    placeholder="货号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.goods_kh"
                    placeholder="款号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.sku"
                    placeholder="SKU"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.city"
                    placeholder="选择城市"
                    multiple
                    @keyup.native.enter="search"
                  >
                    <el-option
                      v-for="item in options.options_supply_city"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pgid"
                    placeholder="选择代采组"
                    filterable
                    clearable
                    @keyup.native.enter="search"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in options.options_pg_group"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.pg_member_id"
                    placeholder="选择代采员"
                    filterable
                    clearable
                    @keyup.native.enter="search"
                  >
                    <el-option value="0" label="全部"></el-option>
                    <el-option
                      v-for="item in options.options_pg_member"
                      :key="item.value"
                      :value="item.value"
                      :label="item.label"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.sku_status"
                    placeholder="sku状态"
                    clearable
                  >
                    <!-- <el-option label="全部" value=""></el-option>-->
                    <el-option
                      v-for="item in skuStatus"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.has_back_time"
                    placeholder="有无承诺回货时间"
                    clearable
                  >
                    <!-- <el-option label="全部" value=""></el-option>-->
                    <el-option
                      v-for="item in hasBackTime"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-select
                    v-model="form.has_reach"
                    placeholder="有无触达"
                    clearable
                  >
                    <!-- <el-option label="全部" value=""></el-option>-->
                    <el-option
                      v-for="item in hasReach"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="需求日期">
                  <el-date-picker
                    v-model="form.demanded_date"
                    type="datetimerange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="起始日期"
                    end-placeholder="截止日期"
                    :default-time="['00:00:00', '23:59:59']"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                  <el-button type="info" @click="reset">重置</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>
            数据列表：<span v-if="resData && resData.total"
              >共{{ resData.total.spu_num }}款，{{
                resData.total.total_num
              }}件，金额￥{{ resData.total.total_price }}</span
            >
          </div>
          <div style="margin-left: auto">
            <el-button type="primary" size="mini" @click="handleExport">
              导出列表
            </el-button>
            <el-button type="success" size="mini" @click="handleExportDetail">
              导出销欠货明细
            </el-button>
          </div>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
            border
          >
            <el-table-column
              prop="demanded_date"
              label="需求日期"
              show-overflow-tooltip
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="supply_name"
              label="商家名称"
              show-overflow-tooltip
              align="center"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="pf_type_msg"
              label="城市/代采组/代采员"
              width="160"
              align="center"
            >
              <template #default="scope">
                <div>{{ scope.row.city }}</div>
                <div>{{ scope.row.pg_name }}</div>
                <div>{{ scope.row.pg_member_name }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="goods_img" label="商品图片" align="center">
              <template #default="scope">
                <div v-viewer style="width: 120px; height: 120px">
                  <img
                    v-for="(item, index) in scope.row.middle_img"
                    :key="item + index"
                    :src="item"
                    style="
                      width: 100%;
                      height: 100%;
                      object-fit: cover;
                      cursor: pointer;
                    "
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="goods_name"
              label="商品名称"
              show-overflow-tooltip
              align="center"
              width="160"
            >
            </el-table-column>
            <el-table-column
              prop="goods_no"
              label="货号"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop="goods_kh"
              label="款号"
              align="center"
              width="120"
            >
            </el-table-column>

            <el-table-column
              prop=""
              label="SKU/颜色/尺码"
              align="center"
              width="130"
            >
              <template #default="scope">
                <div>{{ scope.row.sku }}</div>
                <div>{{ scope.row.co_val }}</div>
                <div>{{ scope.row.si_val }}</div>
              </template>
            </el-table-column>
            <el-table-column
              prop="is_sale"
              label="当前SKU状态"
              align="center"
              width="110"
            >
            </el-table-column>
            <el-table-column
              prop="num"
              label="超3天欠货数"
              width="80"
              align="center"
              show-overflow-tooltip
            >
              <template #header>
                <div>
                  超3天欠货数
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="欠货包含待开单和订单欠货，商家填写货期或超过4天时则不更新"
                    placement="top-start"
                  >
                    <i class="el-icon-question" />
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="price" label="计划代采单价" align="center">
            </el-table-column>

            <el-table-column prop="total_price" label="总金额" align="center">
            </el-table-column>

            <el-table-column
              prop="owe_update_at"
              label="欠货更新时间"
              align="center"
              width="100"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="触达账号/时间"
              align="center"
              width="120"
            >
              <template #default="scope">
                <div>{{ scope.row.reach_by }}</div>
                <div>{{ scope.row.reach_at }}</div>
              </template>
            </el-table-column>

            <el-table-column
              prop="owe_back_at"
              label="欠货承诺回货时间"
              width="140"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop=""
              label="填写人/填写时间"
              width="140"
              align="center"
            >
              <template #default="scope">
                <div>{{ scope.row.fill_by }}</div>
                <div>{{ scope.row.fill_at }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="100"
              align="center"
              fixed="right"
            >
              <template #default="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleDetail(scope.row)"
                  >查看销欠货明细
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="total"
            :page-size="form.pagesize"
            :page-sizes="[20, 50, 100, 200, 500, 1000]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
      <el-dialog :visible.sync="currentOverdueVisible" width="70%">
        <template #title>
          <div>
            入库销欠货明细
            <el-tooltip
              class="item"
              effect="dark"
              content=""
              placement="top-start"
            >
              <template #content>
                超3天的欠货，仅在入库销欠货时记录至此表。<br />
                ① 当欠货为“待开单”时，取在【欠货更新时间】之后提交的订单；<br />
                ②
                当欠货为“订单欠货”时，取欠货id对应的订单，若被重置到待开单，则按①的规则处理。
              </template>
              <i class="el-icon-question" />
            </el-tooltip>
          </div>
        </template>
        <div v-if="overdueDetail">
          <div v-if="currentOverdue" style="display: flex; margin-bottom: 20px">
            <div style="margin-right: 20px">
              需求日期：{{ currentOverdue.demanded_date }}
            </div>
            <div style="margin-right: 20px">
              超3天欠货：共{{ currentOverdue.num }}件
            </div>
            <div style="margin-right: 20px">
              欠货更新时间：{{ currentOverdue.owe_update_at }}
            </div>
            <div style="margin-right: 20px">
              承诺回货时间：{{ currentOverdue.owe_back_at }}
            </div>
          </div>
          <el-table :data="overdueDetail.list">
            <el-table-column
              property="planid"
              label="代采计划单号"
              align="center"
            ></el-table-column>
            <el-table-column
              property="ptype_txt"
              label="计划类型"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="woid"
              label="代采订单"
              align="center"
            ></el-table-column>
            <el-table-column
              property="order_create_time"
              label="订单提交时间"
              align="center"
            >
            </el-table-column>
            <el-table-column
              property="finish_owe_time"
              label="入库销欠货时间"
              align="center"
            >
            </el-table-column>
          </el-table>
          <div style="text-align: right; padding: 25px">
            <el-pagination
              :current-page.sync="overdueDetailPage"
              background
              layout="total, prev, pager, next, jumper "
              :total="Number(overdueDetail.count)"
              :page-size="overdueDetailPageSize"
              :page-sizes="[20, 50, 100, 200, 500, 1000]"
              @size-change="handleDetailPageSizeChange"
              @current-change="handleDetailPageChange"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import {
  postOverdueOptions,
  postExportOverdueDetail,
  postOverdueList,
  postExportOverdueList,
  postOverdueDetail,
} from "@/openapi/erp/wcgOwe.js";

function defaultDate() {
  const endDate = new Date();
  const endM =
    endDate.getMonth() + 1 < 10
      ? `0${endDate.getMonth() + 1}`
      : endDate.getMonth() + 1;
  const end = `${endDate.getFullYear()}-${endM}-${endDate.getDate()}`;

  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 31);
  const startM =
    startDate.getMonth() + 1 < 10
      ? `0${startDate.getMonth() + 1}`
      : startDate.getMonth() + 1;
  const start = `${startDate.getFullYear()}-${startM}-${startDate.getDate()}`;
  return [start, end];
}

export default {
  name: "CompensateList",
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.getOptions();
      vm.fetchData();
    });
  },
  data() {
    return {
      selections: {
        supply: [],
      },
      currentOverdue: null, // 当前消欠货明细弹框id
      overdueDetail: {}, // 当前消欠货明细
      overdueDetailPage: 1,
      overdueDetailPageSize: 20,
      currentOverdueVisible: false, // 是否显示当前消欠货明细弹框
      options: [],
      skuStatus: [
        {
          value: 1,
          label: "启用",
        },
        {
          value: 2,
          label: "禁用",
        },
      ],
      hasBackTime: [
        {
          value: 1,
          label: "有",
        },
        {
          value: 2,
          label: "无",
        },
      ],
      hasReach: [
        {
          value: 1,
          label: "有",
        },
        {
          value: 2,
          label: "无",
        },
      ],
      loading: false,
      filterFold: false,
      resData: null,
      total: 0,
      form: {
        page: 1,
        page_size: 20,
        supply_id: "", // 商家ID
        goods_no: "", // 货号
        goods_kh: "", // 款号
        sku: "", // SKU
        city: [], // 城市
        pgid: "", // 代采组id
        pg_member_id: "", // 代采员id
        sku_status: "", // sku状态
        has_back_time: "", // 有无承诺回货时间
        has_reach: "", // 有无触达
        demanded_date: defaultDate(), // 需求日期
      },
    };
  },
  methods: {
    // 搜索商家
    remoteSupply(e) {
      if (e.length < 3) return;
      this.$http
        .post("/erp/Common/selectSupply", { supply_name: e })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.e(res.data.msg);
            return;
          }
          this.$set(this.selections, "supply", res.data.data);
        });
    },
    handleDetailPageChange(val) {
      this.overdueDetailPage = val;
      this.fetchDetail();
    },
    handleDetailPageSizeChange(val) {
      this.overdueDetailPageSize = val;
      this.fetchDetail();
    },
    getOptions() {
      postOverdueOptions()
        .then((res) => {
          this.options = res;
          console.log("options", this.options);
        })
        .catch(this.$noop);
    },
    search() {
      this.form.page = 1;
      this.fetchData();
    },
    reset() {
      this.form = this.$options.data().form;
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    // 导出列表
    handleExport() {
      postExportOverdueList(this.form)
        .then((data) => {
          this.$message.success("导出成功");
          const { file } = data;
          const downloadUrl = apiBaseURL + file;
          console.log("downloadUrl", downloadUrl);
          window.open(downloadUrl);
        })
        .catch(this.$noop);
    },
    // 导出销欠货明细
    handleExportDetail() {
      postExportOverdueDetail(this.form)
        .then((data) => {
          this.$message.success("导出成功");
          const { file } = data;
          window.open(apiBaseURL + file);
        })
        .catch(this.$noop);
    },
    fetchData() {
      postOverdueList(this.form)
        .then((res) => {
          this.resData = res;
          this.total = (res.total && Number(res.total.count)) || this.total;
        })
        .catch(this.$noop);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData();
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData();
    },

    // 查看详情
    handleDetail(row) {
      this.currentOverdue = row;
      console.log("this.currentOverdue", this.currentOverdue);
      this.overdueDetailPage = this.$options.data().overdueDetailPage;
      this.overdueDetailPageSize = this.$options.data().overdueDetailPageSize;
      this.fetchDetail();
    },
    fetchDetail() {
      postOverdueDetail({
        id: this.currentOverdue.id,
        page: this.overdueDetailPage,
        page_size: this.overdueDetailPageSize,
      }).then((res) => {
        this.overdueDetail = res;
        this.currentOverdueVisible = true;
      });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/Overdue.vue